module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    },
    on: {
      "after-enter": _vm.afterEnter
    }
  }, [_c('div', {
    ref: "popup",
    staticClass: "popup",
    staticStyle: {
      "background-image": "url('static/img/main/point4/popup/bg.png')"
    }
  }, [_c('div', {
    staticClass: "popup-bg delay3"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-inner "
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePopup($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left delay6"
  }, [_c('div', {
    staticClass: "quotes quotes-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Солнечная Сицилия — очень красивый и разнообразный остров, омываемый тремя морями, который подарил мне редкую возможность полного слияния с природой\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                        Сицилия, Италия\n                    ")])]), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                        Солнечная Сицилия\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                        Сицилийские цитрусовые занимают важное место на рынке европейских фруктов: уже 150 лет назад лимонные плантации на острове были самым прибыльным сельскохозяйственным угодьем в Европе, превосходя даже знаменитые фруктовые сады в окрестностях Парижа. Сицилийские лимоны начали культивировать в XVIII веке, и они настолько душисты и сочны, что за их эфирное масло борются ведущие парфюмерные дома. А у Weleda на Сицилии есть сады, в которых биодинамическим способом выращивают органические лимоны. Местные лимоны дарят средствам марки заряд витамина C и яркий запах Средиземноморья.\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right delay9"
  }, [_c('div', {
    staticClass: "popup-products"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v("\n                            Лимон\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                            Эфирное масло и сок лимона — одни из самых важных компонентов косметических средств. Бодрящие ароматы лимона помогают наполнить день позитивом и энергией.\n                    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/%D0%B2%D0%B5%D0%B4%D1%83%D1%89%D0%B8%D0%B5-%D1%80%D0%B0%D1%81%D1%82%D0%B5%D0%BD%D0%B8%D1%8F/%D0%BB%D0%B8%D0%BC%D0%BE%D0%BD?utm_source=afisha&utm_medium=card&utm_content=lemon&utm_campaign=weleda_afisha_sp_summer_2018",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.gaEvents('places', 'click', 'know more ')
      }
    }
  }, [_vm._v("\n                            Подробнее\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/main/point4/popup/product.png",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e44b68c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/popups/popup4.vue
// module id = 549
// module chunks = 1